export const MOCK_ROWS = [
  {
    uid: 302401,
    registerTime: '2026-01-16 10:32:18',
    userType: 2,
    topPartnerUid: 301001,
    topPartnerRebateRate: 0.8,
    kycStatus: 1,
    kycTime: '2026-01-16 11:05:42',
    rebateRiskStatus: false,
    riskRemark: '--',
    spotBalanceUsdt: 103.2746,
    contractBalanceUsdt: 8240.68,
    copyBalanceUsdt: 125.86,
    avgHoldingHours: 3.72,
    holdingLe3mRate: 12.5,
    holdingLe10mRate: 28.75,
    cancelRate: 6.25,
    openCount: 68,
    closeCount: 64,
    tradeCount: 132,
    profitableCloseCount: 41,
    profitableCloseRate: 64.06,
    contractSymbols: 'BTC, ETH, SOL',
    orderIps: '103.28.18.6, 103.28.18.9',
    depositAmountUsdt: 178.8266,
    withdrawAmountUsdt: -41.8466,
    netDepositAmountUsdt: 136.98,
    contractTotalFeeUsdt: -3625.126,
    totalContributionRebateUsdt: 329.8423,
    subordinateContributionRebateUsdt: 1329.668,
    grantedLeaderProfitUsdt: 286.12,
  },
  {
    uid: 302516,
    registerTime: '2026-02-03 08:16:45',
    userType: 2,
    topPartnerUid: 301001,
    topPartnerRebateRate: 0.7,
    kycStatus: 1,
    kycTime: '2026-02-03 09:20:16',
    rebateRiskStatus: false,
    riskRemark: '--',
    spotBalanceUsdt: 53.7284,
    contractBalanceUsdt: 4520.39,
    copyBalanceUsdt: 0,
    avgHoldingHours: 2.35,
    holdingLe3mRate: 8.33,
    holdingLe10mRate: 20.83,
    cancelRate: 4.17,
    openCount: 42,
    closeCount: 39,
    tradeCount: 81,
    profitableCloseCount: 23,
    profitableCloseRate: 58.97,
    contractSymbols: 'BTC, ETH',
    orderIps: '103.28.20.11',
    depositAmountUsdt: 520,
    withdrawAmountUsdt: -120,
    netDepositAmountUsdt: 400,
    contractTotalFeeUsdt: -2150.68,
    totalContributionRebateUsdt: 215.068,
    subordinateContributionRebateUsdt: 0,
    grantedLeaderProfitUsdt: null,
  },
  {
    uid: 303028,
    registerTime: '2026-03-18 16:22:09',
    userType: 1,
    topPartnerUid: null,
    topPartnerRebateRate: null,
    kycStatus: 0,
    kycTime: null,
    rebateRiskStatus: false,
    riskRemark: '--',
    spotBalanceUsdt: 20,
    contractBalanceUsdt: 1000,
    copyBalanceUsdt: 0,
    avgHoldingHours: 1.25,
    holdingLe3mRate: 16.67,
    holdingLe10mRate: 33.33,
    cancelRate: 0,
    openCount: 12,
    closeCount: 10,
    tradeCount: 22,
    profitableCloseCount: 6,
    profitableCloseRate: 60,
    contractSymbols: 'BTC',
    orderIps: '103.28.21.8',
    depositAmountUsdt: 100,
    withdrawAmountUsdt: 0,
    netDepositAmountUsdt: 100,
    contractTotalFeeUsdt: -125.32,
    totalContributionRebateUsdt: 0,
    subordinateContributionRebateUsdt: null,
    grantedLeaderProfitUsdt: null,
  },
  {
    uid: 303116,
    registerTime: '2026-04-07 11:58:32',
    userType: 2,
    topPartnerUid: 301206,
    topPartnerRebateRate: 0.65,
    kycStatus: 1,
    kycTime: '2026-04-08 12:10:30',
    rebateRiskStatus: true,
    riskRemark: '短时高频交易',
    spotBalanceUsdt: 286.59,
    contractBalanceUsdt: 6300.2,
    copyBalanceUsdt: 86.43,
    avgHoldingHours: 0.86,
    holdingLe3mRate: 31.25,
    holdingLe10mRate: 48.44,
    cancelRate: 18.75,
    openCount: 34,
    closeCount: 32,
    tradeCount: 66,
    profitableCloseCount: 18,
    profitableCloseRate: 56.25,
    contractSymbols: 'BTC, ETH, XRP',
    orderIps: '103.28.23.16',
    depositAmountUsdt: 820,
    withdrawAmountUsdt: -260,
    netDepositAmountUsdt: 560,
    contractTotalFeeUsdt: -1320.86,
    totalContributionRebateUsdt: 125.86,
    subordinateContributionRebateUsdt: 85.32,
    grantedLeaderProfitUsdt: 42.66,
  },
]

export const MOCK_DETAILS = {
  spotBalance: [
    { coin: 'USDT', balance: 29.8466 },
    { coin: 'BTC', balance: 0.001 },
    { coin: 'ETH', balance: 0.42 },
  ],
}
